module.exports = __webpack_public_path__ + "images/marketing/inc5000-award.png";